import { render, staticRenderFns } from "./BaseMap.vue?vue&type=template&id=ff4c4fa6&"
import script from "./BaseMap.vue?vue&type=script&lang=js&"
export * from "./BaseMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports